<template>
  <span
    v-if="twoLetterCode"
    class="fi"
    :class="`fi-${twoLetterCode.toLowerCase()}`"
    role="img"
    :aria-label="`Vlajka ${countryCode}`"
  ></span>
</template>

<script setup>
import { computed } from "vue";
import { countryCodeMap } from "@/utils/countryCodes.js";

const props = defineProps({
  countryCode: { type: String, required: true }, // ISO3
});

const convertToTwoLetterCode = code => countryCodeMap[code] || null;
const twoLetterCode = computed(() => convertToTwoLetterCode(props.countryCode));
</script>

<style scoped>
/* jednotná velikost 4:3 */
.fi{
  max-width:24px; max-height:18px;
  border-radius:2px;
  /* kontrastní oddělení od bílého pozadí: */
  box-shadow: 0 0 0 1px rgba(0,0,0,.22);           /* tenký kroužek */
  filter: drop-shadow(0 1px 1px rgba(0,0,0,.10));  /* jemný stín pod vlajkou */
  background-color:#fff;                            
}
</style>
